import { render, staticRenderFns } from "./molisDayDataStatistic.vue?vue&type=template&id=2445b4b1&scoped=true"
import script from "./molisDayDataStatistic.vue?vue&type=script&lang=ts"
export * from "./molisDayDataStatistic.vue?vue&type=script&lang=ts"
import style0 from "./molisDayDataStatistic.vue?vue&type=style&index=0&id=2445b4b1&prod&scoped=true&lang=stylus"
import style1 from "./molisDayDataStatistic.vue?vue&type=style&index=1&id=2445b4b1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2445b4b1",
  null
  
)

export default component.exports